let utils = require( './utils' );

let select_proposal_type = (function( $ ) {

	let $content;

	let _init = function() {
		$content = $( '.choose-proposal-type' );

		if ( $content.length > 0 ) {
			$content.find( '.selector a.proposal-type' ).on( 'click', _switch_type );
			$( '.select-role' ).find( 'a' ).on( 'click', _switch_self_org_role );

			if ( utils.viewport_size().width < 768 ) {
				_setup_choices_toggle();
			}

			if ( utils.viewport_size().width >= 768 ) {
				_set_choice_heights();
				$( window ).smartresize( _set_choice_heights );
			}
		}
	};

	let _set_choice_heights = function() {
		let $types = $content.find( '.choices .proposal-type' ),
			height = 0;

		$types.css( 'height', 'auto' );

		$types.each( function( index, item ) {
			if ( $( item ).outerHeight() > height ) {
				height = $( item ).outerHeight();
			}
		} );

		$types.css( 'height', height );
	};

	let _setup_choices_toggle = function () {
		$content.find( 'a.toggle-choices' ).on( 'click', function( e ) {
			e.preventDefault();

			$content.find( '.selector' ).toggleClass( 'open' );
			$content.find( '.choices' ).slideToggle();
		} );
	};

	let _switch_type = function( e ) {
		e.preventDefault();

		$content.find( '.selector a.proposal-type' ).removeClass( 'active' );
		$( '.proposal-content' ).removeClass( 'active' );

		$( this ).addClass( 'active' );
		$( '.proposal-content.' + $( this ).data( 'type' ) ).addClass( 'active' );

		if ( utils.viewport_size().width < 768 ) {
			$content.find( 'a.toggle-choices .current' ).text(  '- ' + $( this ).find( '.proposal-label' ).text() );
		}
	};

	let _switch_self_org_role = function( e ) {
		e.preventDefault();

		$( '.select-role' ).find( 'a' ).removeClass( 'is-active' );
		$( '.role-content' ).find( '.role' ).removeClass( 'active' );

		$( this ).addClass( 'is-active' );
		$( '.role-content' ).find( '.' + $( this ).data( 'role' ) ).addClass( 'active' );
	};

	$( document ).ready( _init );

	return {};

})( jQuery );

module.exports = select_proposal_type;